// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {}

export const mutations = {}

export const actions = {
  fetchReportsT101(_, payload) {
    return ApiService.fetchReportsT101(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReportsT102(_, payload) {
    return ApiService.fetchReportsT102(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReportsT103(_, payload) {
    return ApiService.fetchReportsT103(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReportsT104(_, payload) {
    return ApiService.fetchReportsT104(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReportsT105(_, payload) {
    return ApiService.fetchReportsT105(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReportsT106(_, payload) {
    return ApiService.fetchReportsT106(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReportsW101(_, payload) {
    return ApiService.fetchReportsW101(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  sendEmailReportsW101(_, payload) {
    return ApiService.sendEmailReportsW101(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  workTimeReprocess(_, payload) {
    return ApiService.workTimeReprocess(payload).catch((error) => {
      throw error
    })
  },
}
